import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=0ae6187f&scoped=true&"
import script from "./AddCollection.vue?vue&type=script&lang=js&"
export * from "./AddCollection.vue?vue&type=script&lang=js&"
import style0 from "./AddCollection.vue?vue&type=style&index=0&id=0ae6187f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6187f",
  null
  
)

export default component.exports